{
  "$id": "module://tax-period",
  "$schema": "wealthlane://schemas/domain",
  "title": "Tax Period",
  "description": "Tax period field catalog",
  "type": "object",
  "properties": {
    "name": {
      "type": "string",
      "title": "Tax Period Name",
      "widget": "text",
      "noBlank": true,
      "maxLength": 100
    },
    "effectiveFrom": {
      "type": "string",
      "title": "Start Date",
      "widget": "date",
      "format": "date",
      "required": true
    },
    "effectiveTill": {
      "type": "string",
      "title": "End Date",
      "widget": "date",
      "format": "date",
      "required": true
    }
  }
}
